const EVENT_VISUALS = {
    TICKET_SLA_OVERDUE: {
        icon: 'feather-alert-octagon',
        tone: 'danger',
        label: 'SLA vencido',
    },
    TICKET_SLA_SOON: {
        icon: 'feather-alert-triangle',
        tone: 'warning',
        label: 'SLA próximo',
    },
    TICKET_ASSIGNED: {
        icon: 'feather-user-check',
        tone: 'info',
        label: 'Asignación',
    },
    TICKET_FOLLOW_CREATED: {
        icon: 'feather-message-square',
        tone: 'info',
        label: 'Seguimiento',
    },
    TICKET_STATUS_CHANGED: {
        icon: 'feather-edit-3',
        tone: 'neutral',
        label: 'Cambio de estado',
    },
    TICKET_REOPENED: {
        icon: 'feather-rotate-ccw',
        tone: 'warning',
        label: 'Reabierto',
    },
    TICKET_CLOSED: {
        icon: 'feather-check-circle',
        tone: 'success',
        label: 'Cerrado',
    },
    TICKET_CREATED: {
        icon: 'feather-file-plus',
        tone: 'neutral',
        label: 'Creado',
    },
};

const DEFAULT_VISUAL = {
    icon: 'feather-bell',
    tone: 'neutral',
    label: 'Notificación',
};

export const getNotificationVisual = (eventType = '') => {
    if (!eventType) {
        return DEFAULT_VISUAL;
    }

    return EVENT_VISUALS[eventType] || DEFAULT_VISUAL;
};
